/* 壹品 手機版「載入更多」：抓下一頁的 section HTML，把 #product-grid 的項目接在現有格線後面
   - 網址同步 ?page=N（replaceState），返回鍵回到同一頁
   - 篩選／排序由 Dawn facets 重繪 #ProductGridContainer，本元件會跟著重建，狀態自然正確
   - 新接上的卡片拿掉 scroll-trigger 浮現，避免停在透明狀態 */
class EepiLoadMore extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('[data-load-more]');
    this.busy = false;
    if (this.btn) this.btn.addEventListener('click', this.onClick.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    if (this.busy) return;
    this.load();
  }

  async load() {
    const next = this.dataset.next;
    /* 分類頁：ul#product-grid.product-grid；搜尋頁：div#product-grid > ul.product-grid */
    const GRID = '#product-grid.product-grid, #product-grid .product-grid';
    const grid = document.querySelector(GRID);
    if (!next || !grid) return;
    this.busy = true;
    this.classList.add('is-loading');
    this.btn.setAttribute('aria-busy', 'true');
    const label = this.btn.textContent;
    this.btn.textContent = '載入中…';
    try {
      const url = new URL(next, location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const newGrid = doc.querySelector(GRID);
      if (!newGrid) throw new Error('no grid');
      const items = Array.from(newGrid.querySelectorAll(':scope > .grid__item'));
      items.forEach((li) => {
        li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
        li.removeAttribute('data-cascade');
        grid.appendChild(li);
      });
      const nextEl = doc.querySelector('eepi-load-more');
      const cleanUrl = new URL(next, location.href);
      cleanUrl.searchParams.delete('section_id');
      history.replaceState(history.state, '', cleanUrl.pathname + cleanUrl.search);
      if (nextEl) {
        this.dataset.next = nextEl.dataset.next;
        this.querySelector('[data-shown]').textContent = nextEl.dataset.shown;
        this.btn.textContent = label;
      } else {
        this.querySelector('[data-shown]').textContent = this.dataset.total;
        this.btn.remove();
        this.classList.add('is-done');
      }
      const first = items[0] && items[0].querySelector('a');
      if (first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: true }); }
    } catch (err) {
      this.btn.textContent = '載入失敗，再試一次';
    } finally {
      this.busy = false;
      this.classList.remove('is-loading');
      if (this.btn) this.btn.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('eepi-load-more')) customElements.define('eepi-load-more', EepiLoadMore);
